<template>
	<div>
		<div v-if="step==1">
			<div class="col text-center text-uppercase">
				<h2>{{'Update Your Password' | trans}}</h2>
			</div>
			<update-password :route='updatePasswordRoute' @passwordUpdated="step=2;"></update-password>
		</div>
		<div v-else-if="step==2">
			<div class="col text-center text-uppercase">
				<h2>{{'Update Your Pin' | trans}}</h2>
			</div>
			<update-pin :route='updatePinRoute' @pinUpdated="updateLastLogin"></update-pin>
		</div>
		<div v-else>
			<div v-show="isLoading" class="d-flex align-items-center justify-content-center">
				<grid-loader :loading="isLoading" :color="spinner.color" :size="spinner.size"></grid-loader>
			</div>
		</div>
	</div>
</template>

<script>
	import GridLoader from 'vue-spinner/src/GridLoader.vue';
	export default {
		name: "update-password-pin",
		components: {
			'GridLoader': GridLoader,
		},
		props: ['route', 'redirectRoute', 'updatePasswordRoute', 'updatePinRoute'],
		data() {
			return {
				isPending: false,
				step: 1,
				isLoading: false
			}
		},
		methods: {
			async updateLastLogin() {
				this.step=3;
				this.isLoading = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				await axios.post(this.route, {})
					.then(() => {
						this.EventBus.$emit('event-success', Lang.get('Success'));
						setTimeout(() => window.location.href = this.redirectRoute, this.beforeRedirectTimeOut)
					})
					.finally(() => {

					});
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/update-password-pin.vue